export default __webpack_public_path__ + "static/media/gallery_10.144c85b0.jpg";